module.exports = __webpack_public_path__ + "static/kpmg_logo2-dd3e2f287cfa519681f26bac7920b4f5.png";